import { cva } from 'class-variance-authority';

export const weightVariants = cva('', {
  variants: {
    weight: {
      regular: 'prose-p:font-normal',
      medium: 'prose-p:font-medium',
      'semi-bold': 'prose-p:font-semibold',
      bold: 'prose-p:font-bold',
      light: 'prose-p:font-light',
    },
  },
});
